import { useEffect } from 'react';
import { useDetectDevice } from './useDetectDevice';

const useScrollToTop = (isForceScroll = false) => {
  const { isDesktop } = useDetectDevice();
  useEffect(() => {
    if (!isForceScroll && !isDesktop) return;
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [isDesktop]);
};

export default useScrollToTop;
